// All user-facing UI strings live here, keyed by id. Add a new language by
// duplicating the object and translating each value. Strings can include
// `{name}` placeholders that the `t()` helper interpolates.

export const TRANSLATIONS = {
  en: {
    // Nav
    'nav.home': 'HOME',
    'nav.about': 'ABOUT',
    'nav.crafting': 'CRAFTING',
    'nav.store': 'STORE',
    'nav.news': 'NEWS',
    'nav.sapphires_bag': 'SAPPHIRES BAG',
    'nav.sign_in': 'SIGN IN',
    'nav.account': 'ACCOUNT',
    'nav.menu': 'menu',

    // Footer
    'footer.terms': 'TERMS AND CONDITIONS',
    'footer.support': 'SUPPORT THE PROJECT',
    'footer.copyright': '© 2024-2025 BY NEWREALMONLINE LTD.',
    'footer.follow_us': 'Follow us',

    // Home hero
    'home.hero.tagline':
      'A revolutionary 2D isometric MMORPG. Forge your destiny in the land of Eldoria, where elemental powers and epic adventures await.',
    'home.hero.cta_enter': 'ENTER THE REALM',
    'home.hero.cta_store': 'VISIT STORE',
    'home.hero.discover_more': 'DISCOVER MORE',

    // Founder promo
    'founder.eyebrow': 'LIMITED TIME · BEFORE BETA LAUNCH',
    'founder.title_top': 'BECOME A',
    'founder.title_bottom': 'FOUNDER',
    'founder.lead_part1': 'Every donation made',
    'founder.lead_emph': 'before beta launch',
    'founder.lead_part2_before': 'grants you a one-of-a-kind',
    'founder.lead_part2_after': 'in-game title. Once beta opens, the title can',
    'founder.lead_never': 'never',
    'founder.lead_end': 'be minted again.',
    'founder.preview_caption_part1': 'Your',
    'founder.preview_caption_part2':
      'badge floats above your character in town and during chat — a permanent mark of being here from day one.',
    'founder.stat_donors_label': 'FOUNDERS SO FAR',
    'founder.stat_donors_sub': 'adventurers backing the realm',
    'founder.stat_raised_label': 'RAISED FOR ELDORIA',
    'founder.stat_raised_sub': 'fueling pixels, servers & coffee',
    'founder.stat_count_label': 'TOTAL DONATIONS',
    'founder.stat_count_sub': 'closes when beta opens',
    'founder.cta': 'CLAIM YOUR FOUNDER TITLE',
    'founder.fine_print':
      'Any donation amount qualifies. The Founder title is minted on a one-per-donor basis and is permanently retired the day beta opens.',

    // Donate page
    'donate.back': 'BACK HOME',
    'donate.eyebrow': 'SUPPORT THE PROJECT',
    'donate.title_top': 'FUEL THE',
    'donate.title_bottom': 'REALM',
    'donate.intro':
      'New Realm Online is built with love by a tiny team. Every donation helps us pay for servers, art, and a few cups of coffee. Thank you for keeping Eldoria alive.',
    'donate.choose_amount': 'CHOOSE AN AMOUNT',
    'donate.or_custom': 'OR ENTER A CUSTOM AMOUNT',
    'donate.message_optional': 'MESSAGE (OPTIONAL)',
    'donate.message_placeholder': 'Say hi to the dev team…',
    'donate.show_name': 'Show my name on the Supporters Wall',
    'donate.display_name_placeholder': 'Name to show (leave blank to use your first name)',
    'donate.see_wall': 'SEE THE SUPPORTERS WALL',
    'wall.back': 'BACK TO DONATE',
    'wall.eyebrow': 'HALL OF HEROES',
    'wall.title_top': 'OUR',
    'wall.title_bottom': 'SUPPORTERS',
    'wall.intro': 'Every name here helped keep the lights on in Eldoria. Thank you, heroes.',
    'wall.empty': 'No supporters yet. Your name could be the first on the wall!',
    'wall.anonymous': 'Anonymous Hero',
    'wall.cta': 'JOIN THE WALL',
    'donate.button_redirecting': 'REDIRECTING…',
    'donate.button_donate': 'DONATE',
    'donate.secure_note':
      'Secure one-time payment by Stripe · EUR · no recurring charge',
    'donate.result.could_not_verify': 'Could not verify',
    'donate.result.thank_you': 'Thank you!',
    'donate.result.thank_you_body':
      'Your donation means the world to us. Eldoria gets a little brighter today.',
    'donate.result.expired': 'Session expired',
    'donate.result.expired_body':
      'The checkout expired before payment was completed.',
    'donate.result.processing': 'Processing',
    'donate.result.processing_body':
      'Hang tight — verifying your donation with Stripe…',
    'donate.result.close': 'CLOSE',
    'donate.canceled_title': 'Donation canceled',
    'donate.canceled_body': 'No charge was made.',
    'donate.toast_pick_title': 'Pick an amount',
    'donate.toast_pick_body': 'Minimum donation is €1.',
    'donate.toast_failed_title': 'Donation failed',
    'donate.toast_failed_body': 'Could not start donation.',
    'donate.toast_verify_failed': 'Could not verify donation.',

    // Cookies
    'cookie.title': 'We use cookies',
    'cookie.body':
      'This website uses cookies to ensure you get the best experience.',
    'cookie.accept': 'ACCEPT ALL',
    'cookie.reject': 'REJECT ALL',
    'cookie.manage': 'MANAGE PREFERENCES',

    // Language switch
    'lang.switch_to': 'Switch to {lang}',
    'lang.english': 'English',
    'lang.spanish': 'Spanish',
  },

  es: {
    // Nav
    'nav.home': 'INICIO',
    'nav.about': 'JUEGO',
    'nav.crafting': 'ARTESANÍA',
    'nav.store': 'TIENDA',
    'nav.news': 'NOTICIAS',
    'nav.sapphires_bag': 'BOLSA DE ZAFIROS',
    'nav.sign_in': 'INICIAR SESIÓN',
    'nav.account': 'CUENTA',
    'nav.menu': 'menú',

    // Footer
    'footer.terms': 'TÉRMINOS Y CONDICIONES',
    'footer.support': 'APOYAR EL PROYECTO',
    'footer.copyright': '© 2024-2025 NEWREALMONLINE LTD.',
    'footer.follow_us': 'Síguenos',

    // Home hero
    'home.hero.tagline':
      'Un MMORPG isométrico 2D revolucionario. Forja tu destino en la tierra de Eldoria, donde te esperan poderes elementales y aventuras épicas.',
    'home.hero.cta_enter': 'ENTRA AL REINO',
    'home.hero.cta_store': 'VISITAR TIENDA',
    'home.hero.discover_more': 'DESCUBRIR MÁS',

    // Founder promo
    'founder.eyebrow': 'TIEMPO LIMITADO · ANTES DEL LANZAMIENTO BETA',
    'founder.title_top': 'CONVIÉRTETE EN',
    'founder.title_bottom': 'FUNDADOR',
    'founder.lead_part1': 'Cada donación realizada',
    'founder.lead_emph': 'antes del lanzamiento de la beta',
    'founder.lead_part2_before': 'te otorga un título único de',
    'founder.lead_part2_after':
      'en el juego. Una vez que abra la beta, el título',
    'founder.lead_never': 'nunca',
    'founder.lead_end': 'volverá a acuñarse.',
    'founder.preview_caption_part1': 'Tu insignia de',
    'founder.preview_caption_part2':
      'flota sobre tu personaje en el pueblo y durante el chat — una marca permanente de haber estado aquí desde el primer día.',
    'founder.stat_donors_label': 'FUNDADORES HASTA AHORA',
    'founder.stat_donors_sub': 'aventureros apoyando el reino',
    'founder.stat_raised_label': 'RECAUDADO PARA ELDORIA',
    'founder.stat_raised_sub': 'financiando píxeles, servidores y café',
    'founder.stat_count_label': 'DONACIONES TOTALES',
    'founder.stat_count_sub': 'se cierra cuando empieza la beta',
    'founder.cta': 'RECLAMA TU TÍTULO DE FUNDADOR',
    'founder.fine_print':
      'Cualquier importe de donación califica. El título de Fundador se acuña una vez por donante y se retira permanentemente el día que abre la beta.',

    // Donate page
    'donate.back': 'VOLVER AL INICIO',
    'donate.eyebrow': 'APOYAR EL PROYECTO',
    'donate.title_top': 'IMPULSA EL',
    'donate.title_bottom': 'REINO',
    'donate.intro':
      'New Realm Online lo construye con cariño un equipo diminuto. Cada donación nos ayuda a pagar servidores, arte y unas cuantas tazas de café. Gracias por mantener viva a Eldoria.',
    'donate.choose_amount': 'ELIGE UNA CANTIDAD',
    'donate.or_custom': 'O INTRODUCE UNA CANTIDAD PERSONALIZADA',
    'donate.message_optional': 'MENSAJE (OPCIONAL)',
    'donate.message_placeholder': 'Saluda al equipo de desarrollo…',
    'donate.show_name': 'Mostrar mi nombre en el Muro de Colaboradores',
    'donate.display_name_placeholder': 'Nombre a mostrar (déjalo vacío para usar tu nombre)',
    'donate.see_wall': 'VER EL MURO DE COLABORADORES',
    'wall.back': 'VOLVER A DONAR',
    'wall.eyebrow': 'SALÓN DE HÉROES',
    'wall.title_top': 'NUESTROS',
    'wall.title_bottom': 'COLABORADORES',
    'wall.intro': 'Cada nombre aquí ayudó a mantener encendidas las luces de Eldoria. Gracias, héroes.',
    'wall.empty': 'Aún no hay colaboradores. ¡Tu nombre podría ser el primero!',
    'wall.anonymous': 'Héroe Anónimo',
    'wall.cta': 'ÚNETE AL MURO',
    'donate.button_redirecting': 'REDIRIGIENDO…',
    'donate.button_donate': 'DONAR',
    'donate.secure_note':
      'Pago único seguro con Stripe · EUR · sin cargos recurrentes',
    'donate.result.could_not_verify': 'No se pudo verificar',
    'donate.result.thank_you': '¡Gracias!',
    'donate.result.thank_you_body':
      'Tu donación significa el mundo para nosotros. Eldoria brilla un poco más hoy.',
    'donate.result.expired': 'Sesión expirada',
    'donate.result.expired_body':
      'El pago expiró antes de completarse.',
    'donate.result.processing': 'Procesando',
    'donate.result.processing_body':
      'Espera un momento — verificando tu donación con Stripe…',
    'donate.result.close': 'CERRAR',
    'donate.canceled_title': 'Donación cancelada',
    'donate.canceled_body': 'No se realizó ningún cargo.',
    'donate.toast_pick_title': 'Elige una cantidad',
    'donate.toast_pick_body': 'La donación mínima es €1.',
    'donate.toast_failed_title': 'Donación fallida',
    'donate.toast_failed_body': 'No se pudo iniciar la donación.',
    'donate.toast_verify_failed': 'No se pudo verificar la donación.',

    // Cookies
    'cookie.title': 'Usamos cookies',
    'cookie.body':
      'Este sitio web usa cookies para garantizar la mejor experiencia.',
    'cookie.accept': 'ACEPTAR TODO',
    'cookie.reject': 'RECHAZAR TODO',
    'cookie.manage': 'GESTIONAR PREFERENCIAS',

    // Language switch
    'lang.switch_to': 'Cambiar a {lang}',
    'lang.english': 'Inglés',
    'lang.spanish': 'Español',
  },
};

export const SUPPORTED_LANGS = ['en', 'es'];
export const DEFAULT_LANG = 'en';
